<template>
  <div class="page">
    <div class="m-content">
      <p class="m-tit">{{moreDetail.title}}</p>
      <div class="m-html ql-editor" v-html="moreDetail.content"></div>
      <div class="m-down-a">
        <!--v-for="(item,index) in bannerList" :key="index"-->
        <a v-for="(item,index) in aDown" class="book-link" :href="item" :download="'附件'+index+1" :key="index">{{'附件'+(index+1)}}</a>
      </div>
    </div>
    <div v-if="!this.$route.query.examId" class="m-footer x-flex-center">
      <van-button block class="x-btn-log m-btn" @click="goTo()">
        我已阅读并了解
      </van-button>
    </div>
    <div v-if="this.$route.query.examId" class="m-footer x-flex-center">
      <div class="m-black">
        <van-icon name="arrow-left" @click="$router.go(-1)"/>
      </div>
      <van-button block class="x-btn-log m-btn1" @click="goDown()">
        我已阅读并下载准考证
      </van-button>
    </div>
    <div v-if="this.$route.query.historyId||this.$route.query.recheckId" class="m-footer x-flex-center">
      <van-button block class="x-btn-log m-btn" @click="goHis()">
        我已阅读并了解
      </van-button>
    </div>
    <!--弹出退出确认框-->
    <van-popup v-model="show" round get-container="body">
      <div class="m-popup">
        <div class="m-title">是否下载准考证</div>
        <div class="m-chose">
          <p @click="show=false">取消</p>
          <p @click="getDown()">
            确定
          </p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import { Dialog } from 'vant';
  export default {
    components: {[Dialog.Component.name]: Dialog.Component},
    computed: {
      ...mapGetters({
        CONFIG_ITEM: 'enroll/configItem'
      })
    },
    data () {
      return {
        moreDetail:{},
        aDown:[],
        title:'',
        hrefUrl:'',
        show:false,
        setId:'',
        token:window.localStorage.getItem('token'),
        people:{},
        register:{},
      }
    },
    created () {
      // 添加 popstate 事件监听
      if(this.$route.query.examId){
        this.getMore(this.$route.query.examId)
      }else if(this.$route.query.historyId){
        this.getMore(this.$route.query.historyId)
      }else if(this.$route.query.recheckId){
        this.getMore(this.$route.query.recheckId)
      } else {
        window.history.pushState(null, null, window.location.href);
        window.addEventListener('popstate', this.onPopState);
        this.getMore()
        this.getInfo()
      }

    },
    methods: {
      goTo(){
        let msg = new FormData()
        msg.append('logType', 1)
        this.http.postRequest({
          url: 'app/user/log/save',
          headers: {'Content-Type': 'multipart/form-data'},
          msg:msg,
          success:(res)=>{

          }
        })
        if(this.CONFIG_ITEM&&this.CONFIG_ITEM.hasNeedNameAccess==1){
          if(this.people.hasNameAccess!=1){
            this.utils.toastNone('此账号为未实名或已过期的状态，请去个人中心实名认证！')
            return
          }
          if(this.register.hasFaceRecognize==1){
            this.$router.push({
              path:this.register.recognizeType==1 ? '/livingFace' : '/face',
            })
          }else {
            this.$router.push({
              path: '/examInfo',
            })
          }
        } else {
          this.$router.push({
            path: '/examInfo',
          })
        }
      },
      getMore(i){
        let url = ''
        if(i){
          if(this.$route.query.historyId){
            url = `app/exam/findGradeNotice/${i}`
          } else if(this.$route.query.recheckId) {
            url = `app/exam/findRecheckNotice/${i}`
          }  else {
            url = `app/exam/findAdmissionNotice/${i}`
          }
//          url = this.$route.query.examId ? `app/exam/findAdmissionNotice/${i}` : `app/exam/findGradeNotice/${i}`
        } else {
          url = `app/exam/findExamNotice/${this.CONFIG_ITEM&&this.CONFIG_ITEM.id ? this.CONFIG_ITEM.id : ''}`
        }
        this.http.getRequest({
          url:url,
          msg:{},
          success:(res)=>{
            this.moreDetail = res.data ? res.data : {}
            if(res.data&&res.data.annex){
              this.aDown = res.data.annex.split(',')
            }
          }
        })
      },
      goDown(){
        this.show = true
        this.setId = this.$route.query.examId
      },
      getDown(){
        window.open(`/api/app/exam/downLoadAdmission/${this.setId}?token=${this.token}`)
        this.show = false
      },
      //    获取个人信息
      getInfo () {
        this.http.postRequest({
          url: 'app/user/getUserInfo',
          msg: {},
          success: (res) => {
            this.people = res.data
            this.http.getRequest({
              url:`app/exam/findRegisterInfo/${this.CONFIG_ITEM.id}`,
              msg:{},
              success:(res)=>{
                this.register = res.data&&res.data.register ? res.data&&res.data.register : {}
              }
            })
          }
        })
      },
      onPopState(e) {
        if(this.$route.query.examId||this.$route.query.historyId||this.$route.query.recheckId){
          window.removeEventListener('popstate', this.onPopState)
          window.history.go(-1)
          return
        }
        window.history.pushState(null, null, window.location.href)
        Dialog.confirm({
          title: ' 是否退出报名？',
          message: '请仔细阅读须知内容并点击我已阅读并了解退出报名。',
          confirmButtonText:'我已阅读并退出',
          confirmButtonColor:'#1989fa',
        }).then(() => {
          let msg = new FormData()
          msg.append('logType', 1)
          this.http.postRequest({
            url: 'app/user/log/save',
            headers: {'Content-Type': 'multipart/form-data'},
            msg:msg,
            success:(res)=>{
              window.removeEventListener('popstate', this.onPopState)
              this.$router.push('/examHome')
            }
          })
        }).catch(() => {
           window.history.pushState(null, null, window.location.href) 
        });
      },
      goHis(){
        if(this.$route.query.historyId){
          this.$router.replace({
            path: '/publicity',
            query: {
              id: this.$route.query.historyId
            }
          })
        }
        if(this.$route.query.recheckId){
          this.$router.replace({
            path: '/gradeDetail',
            query: {
              id: this.$route.query.recheckId
            }
          })
        }
      }
    },
    mounted () {

    },
    beforeDestroy() {
      // 在组件销毁前，移除 popstate 事件监听
      window.removeEventListener('popstate', this.onPopState)
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page{
    background:#F4F6F9;
    .m-content{
      position: absolute;
      top: 12px;
      left: 12px;
      right: 12px;
      bottom: 12px;
      margin: auto;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      z-index: 2;
      background: #ffffff;
      border-radius: 4px;
      padding-bottom: 65px;
      .m-tit{
        padding: 10px;
        text-align: center;
        font-size: 15px;
        font-weight: bold;
      }
      .m-html{
        padding: 10px;
        /deep/b{
          font-weight: 600;
        }
        /deep/img{
          max-width: 100%;
          object-fit: contain;
        }
      }
      .ql-editor{
        height: inherit!important;
      }
      .m-down-a{
        padding: 30px 20px 80px 20px;
        .book-link{
          display: block;
          color: #2B6CF9;
          margin-bottom: 10px;           
        }
      }
    }
    .m-footer{
      height: 60px;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 15;
      background: #ffffff;
      align-items: center;
      .m-btn{
        width: 135px;
      }
      .m-btn1{
        width: 180px;
      }
      .m-black{
        width: 35px;
        height: 35px;
        border-radius: 50%;
        background: #2B6CF9;
        text-align: center;
        line-height: 35px;
        color: white;
        font-size: 20px;
        position: absolute;
        left: 15px;
      }
    }
  }
  .m-popup {
    width: 300px;
    height: 103px;
    background: #ffffff;
    font-size: 15px;
    overflow: hidden;
    .m-title {
      text-align: center;
      font-size: 15px;
      font-weight: bold;
      height: 53px;
      line-height: 53px;
      border-bottom: 1Px solid #E7E7E7;
    }
    .m-chose {
      display: flex;
      > p {
        flex: 1;
        text-align: center;
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        font-weight: bold;
      }
      > p:nth-child(2) {
        color: #2B6CF9;
        border-left: 1Px solid #E7E7E7;
      }
      a{
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }

  .van-popup--center.van-popup--round {
    border-radius: 4px !important;
  }
</style>

